import { Popover as MuiPopover } from '@mui/material';
import type { PopoverProps as MuiPopoverProps } from '@mui/material';

export type PopoverProps = MuiPopoverProps;

/** Basic popover component to display elements in a overlay. Based on https://mui.com/material-ui/react-popover/ */
export const Popover = (props: MuiPopoverProps) => <MuiPopover {...props} />;
